import React, { useState, useEffect, useCallback } from 'react';
import { toast } from 'react-toastify';
import { recitalService } from '../../services/RecitalService';
import RecitalList from './components/RecitalList';
import CreateRecitalModal from './components/CreateRecitalModal';
import RecitalEditor from './components/RecitalEditor';
import styles from './index.module.scss';

export default function Recitals() {
    const [recitals, setRecitals]             = useState([]);
    const [currentRecital, setCurrentRecital] = useState(null);
    const [loading, setLoading]               = useState(true);
    const [showCreateModal, setShowCreateModal] = useState(false);

    const loadRecitals = useCallback(async () => {
        setLoading(true);
        try {
            const res = await recitalService.getRecitals();
            setRecitals(res.data.recitals || []);
        } catch (e) {
            console.error('Failed to load recitals', e);
            toast.error('Could not load your recitals. Please refresh the page.');
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => { loadRecitals(); }, [loadRecitals]);

    const openRecital = async (id) => {
        try {
            const res = await recitalService.getRecital(id);
            setCurrentRecital(res.data.recital);
        } catch (e) {
            console.error('Failed to load recital', e);
            toast.error('Could not open that recital. Please try again.');
        }
    };

    const handleCreated = async (recital) => {
        setShowCreateModal(false);
        await loadRecitals();
        openRecital(recital.id);
    };

    const handleDelete = async (id) => {
        if (!window.confirm('Delete this recital? This cannot be undone.')) return;
        await recitalService.deleteRecital(id);
        if (currentRecital?.id === id) setCurrentRecital(null);
        loadRecitals();
    };

    if (currentRecital) {
        return (
            <RecitalEditor
                recital={currentRecital}
                onBack={() => { setCurrentRecital(null); loadRecitals(); }}
                onUpdate={setCurrentRecital}
            />
        );
    }

    return (
        <div className={styles.page}>
            {showCreateModal && (
                <CreateRecitalModal
                    onClose={() => setShowCreateModal(false)}
                    onCreated={handleCreated}
                />
            )}
            <RecitalList
                recitals={recitals}
                loading={loading}
                onOpen={openRecital}
                onDelete={handleDelete}
                onNew={() => setShowCreateModal(true)}
            />
        </div>
    );
}
